<template>
  <div>
    <div class="toolbar">
      <h2>操作日志</h2>
      <el-button @click="load">刷新</el-button>
    </div>
    <div v-if="!isMobile" class="table-scroll">
    <el-table :data="list" v-loading="loading" border>
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column label="时间" width="170">
        <template slot-scope="{ row }">{{ formatTime(row.created_at) }}</template>
      </el-table-column>
      <el-table-column prop="admin_username" label="操作人" width="120" />
      <el-table-column label="动作" width="90">
        <template slot-scope="{ row }">{{ formatAction(row.action) }}</template>
      </el-table-column>
      <el-table-column label="对象类型" width="120">
        <template slot-scope="{ row }">{{ formatTargetType(row.target_type) }}</template>
      </el-table-column>
      <el-table-column prop="target_id" label="对象ID" width="80" />
      <el-table-column prop="ip" label="IP" width="130" />
      <el-table-column label="详情">
        <template slot-scope="{ row }">
          <span class="detail">{{ formatDetail(row.detail) }}</span>
        </template>
      </el-table-column>
    </el-table>
    </div>

    <MobileCardList
      v-if="isMobile"
      :data="list"
      :loading="loading"
      :fields="cardFields"
    >
      <template #created_at="{ row }">{{ formatTime(row.created_at) }}</template>
      <template #action="{ row }">{{ formatAction(row.action) }}</template>
      <template #target_type="{ row }">{{ formatTargetType(row.target_type) }}</template>
      <template #detail="{ row }">
        <span class="detail">{{ formatDetail(row.detail) }}</span>
      </template>
    </MobileCardList>
  </div>
</template>

<script>
import { api } from '../api';
import responsiveMixin from '../mixins/responsive';
import { formatDateTime } from '../utils/listHelpers';

const ACTION_LABELS = {
  login: '登录',
  create: '新增',
  update: '修改',
  delete: '删除',
  assign: '分配',
  broadcast: '广播',
  cancel: '取消',
  change_password: '修改密码',
};

const TARGET_LABELS = {
  auth: '账号',
  settings: '系统设置',
  main_category: '大分类',
  sub_category: '小分类',
  merchant: '商家',
  ad: '广告',
  ad_schedule: '定时广告',
};

export default {
  name: 'Logs',
  mixins: [responsiveMixin],
  data() {
    return {
      list: [],
      loading: false,
      cardFields: [
        { label: 'ID', prop: 'id' },
        { label: '时间', prop: 'created_at' },
        { label: '操作人', prop: 'admin_username' },
        { label: '动作', prop: 'action' },
        { label: '对象类型', prop: 'target_type' },
        { label: '对象ID', prop: 'target_id' },
        { label: 'IP', prop: 'ip' },
        { label: '详情', prop: 'detail', block: true },
      ],
    };
  },
  created() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        const { data } = await api.logs.list({ limit: 100 });
        this.list = data;
      } catch (e) {
        this.$message.error(e.message);
      } finally {
        this.loading = false;
      }
    },
    formatAction(action) {
      return ACTION_LABELS[action] || action;
    },
    formatTargetType(type) {
      return TARGET_LABELS[type] || type;
    },
    formatDetail(detail) {
      if (!detail) return '-';
      if (typeof detail === 'object') return JSON.stringify(detail);
      try {
        return JSON.stringify(JSON.parse(detail));
      } catch {
        return String(detail);
      }
    },
    formatTime(val) {
      return formatDateTime(val);
    },
  },
};
</script>

<style scoped>
.toolbar { display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px; }
.toolbar h2 { margin: 0; }
.detail { font-size: 0.32rem; word-break: break-all; }
</style>
